import * as z from 'zod';

import { bdQuerySchema } from './bd-query-schema';

export const bdUpdateSchema = bdQuerySchema.pick({ id: true, name: true, abbreviation: true }).extend({
  logo_dark: z.array(z.number()).nullable(),
  logo_light: z.array(z.number()).nullable(),
  status: z.string(),
});

export type BdUpdateSchema = z.infer<typeof bdUpdateSchema>;

export const bdCreateSchema = bdUpdateSchema.pick({ name: true, abbreviation: true, status: true });

export type BdCreateSchema = z.infer<typeof bdCreateSchema>;
